import type { TranslationMessages } from '../../types';

export const point_store: TranslationMessages = {
  title: 'Cửa hàng điểm',
  subtitle: 'Đổi điểm đã kiếm được của bạn để nhận phần thưởng',
  loading: 'Đang tải cửa hàng điểm...',
  available_items: 'Mục có sẵn',
  categories: 'Danh mục',
  cash_redemption: 'Đổi tiền mặt',
  items: 'Mục',
  experiences: 'Trải nghiệm',
  gacha: 'Gacha',
  redeem: 'Đổi thưởng',
  points_cost: 'Chi phí điểm',
  cash_value: 'Giá trị tiền mặt',
  stock_available: 'Còn hàng',
  out_of_stock: 'Hết hàng',
  redemption_amount: 'Số tiền đổi thưởng',
  minimum_redemption: 'Số tiền đổi thưởng tối thiểu',
  confirm_redemption: 'Xác nhận đổi thưởng',
  redemption_confirmation: 'Xác nhận đổi thưởng',
  redemption_successful: 'Đổi thưởng thành công',
  insufficient_points: 'Không đủ điểm',
  gacha_box: 'Hộp Gacha',
  draw_gacha: 'Rút Gacha',
  gacha_result: 'Kết quả Gacha',
  congratulations: 'Chúc mừng!',
  you_won: 'Bạn đã thắng',
  stats_available: 'Có sẵn',
  stats_pending: 'Đang chờ',
  stats_total: 'Tổng cộng',
  stats_lifetime: 'Trọn đời',
  search_items: 'Tìm kiếm mục',
  search_placeholder: 'Tìm kiếm theo tên, mô tả hoặc thẻ...',
  category_label: 'Danh mục',
  all_categories: 'Tất cả danh mục',
  popular: 'Phổ biến',
  limited: 'Giới hạn',
  points: 'điểm',
  stock_remaining: 'Còn lại: %{count}',
  redeem_now: 'Đổi ngay',
  recent_redemptions: 'Đổi thưởng gần đây',
  recent_redemptions_desc:
    'Các lần đổi điểm gần đây của bạn và trạng thái của chúng',
  no_redemptions: 'Chưa có lần đổi thưởng nào',
  failed_load: 'Không thể tải dữ liệu cửa hàng',
  insufficient_for_item: 'Không đủ điểm cho mục này',
  item_out_of_stock: 'Mục này đã hết hàng',
  redeem_success: 'Đã đổi %{name} thành công!',
  status_pending: 'Đang chờ',
  status_approved: 'Đã duyệt',
  status_completed: 'Đã hoàn thành',
  status_cancelled: 'Đã hủy',
};
